<template>
    <div>
        <Breadtabsheader/>
        <div class="h-content" style="">
            <div class=" ">
                <el-tabs v-model="activeName" type="border-card">
                    <el-tab-pane label="传统" name="first" :key="'first'" v-if="hasAuth('customerCountTable')">
                        <customerCountTable v-if="activeName === 'first'" />
                    </el-tab-pane>
                    <el-tab-pane label="血液" name="second" :key="'second'" v-if="hasAuth('customerCountTableXY')">
                        <customerCountTableXY v-if="activeName === 'second'" />
                    </el-tab-pane>
                    <el-tab-pane label="厚宏" name="third" :key="'third'" v-if="hasAuth('customerCountTableHH')">
                        <customerCountTableHH v-if="activeName === 'third'" />
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import customerCountTable from './customerCountTable.vue'
import customerCountTableXY from './customerCountTableXY.vue'
import customerCountTableHH from './customerCountTableHH.vue'
export default {
    components: {
        customerCountTable,
        customerCountTableXY,
        customerCountTableHH,
    },
    data() {
        return {
            activeName: "first",
        };
    },
    created() {
        // 标签页权限配置
        const tabs = [
            { name: 'first', auth: 'customerCountTable' },
            { name: 'second', auth: 'customerCountTableXY' },
            { name: 'third', auth: 'customerCountTableHH' }
        ];
        
        // 获取第一个有权限的标签名
        const firstAuthTab = tabs.find(tab => this.hasAuth(tab.auth));
        
        if (this.$route.query.type && this.hasAuth(this.getTabAuth(this.$route.query.type))) {
            this.activeName = this.$route.query.type;
        } else if (firstAuthTab) {
            this.activeName = firstAuthTab.name;
        }
    },
    methods: {
        handleClick(tab) {
        },
        hasAuth(code) {
            return this.$store.getters.rescodelist.includes(code);
        },
        getTabAuth(name) {
            const authMap = {
                'first': 'customerCountTable',
                'second': 'customerCountTableXY',
                'third': 'customerCountTableHH'
            };
            return authMap[name];
        }
    }
}
</script>
<style scoped>
.h-content{
    background: #fff
}
</style>
